var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.sendBranchWindow.visible,
            title: _vm.sendBranchWindow.title,
            width: "360px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.sendBranchWindow, "visible", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "96px", "label-position": "right" } },
            _vm._l(_vm.sendBranchWindow.items, function(item, index) {
              return _c(
                "el-form-item",
                { key: index, attrs: { label: item.userLabel } },
                [
                  _c("cargo-user-select", {
                    attrs: {
                      "method-params": {
                        officeId: _vm.sendBranchWindow.officeId,
                        category: "role",
                        shape: item.shape
                      },
                      "default-value": item.userId || ""
                    },
                    on: {
                      change: function(p) {
                        item.userId = p.value
                        _vm.userId_changeHandler(item)
                      }
                    }
                  })
                ],
                1
              )
            }),
            1
          ),
          _c(
            "div",
            {
              staticStyle: { margin: "0 auto", width: "fit-content" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.enterSendHandler }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.sendBranchWindow.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }